"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationBase = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const ConversationBase = ({ children, image }) => {
    return (react_1.default.createElement(react_native_1.View, { style: styles.container },
        image ? react_1.default.createElement(react_native_1.View, { style: styles.imageWrapper }, image) : null,
        react_1.default.createElement(react_native_1.View, { style: [styles.content] }, children)));
};
exports.ConversationBase = ConversationBase;
const styles = react_native_1.StyleSheet.create({
    container: {
        flexDirection: 'row',
    },
    content: {
        flex: 1,
        minHeight: 55,
    },
    contentBottomBorder: {
        borderBottomWidth: react_native_1.StyleSheet.hairlineWidth,
    },
    imageWrapper: {
        alignItems: 'center',
        marginRight: 16,
    },
});
